var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("radio-button-row", {
        key: _vm.radioButtonValueChanged,
        attrs: {
          title: "AidApplication.BasicInfo.OtherOperation.HasOtherOperation",
          instructionsKey:
            "AidApplication.BasicInfo.OtherOperation.HasOtherOperation_Instructions",
          required: true
        },
        model: {
          value: _vm.otherOperation.hasOtherOperation,
          callback: function($$v) {
            _vm.$set(_vm.otherOperation, "hasOtherOperation", $$v)
          },
          expression: "otherOperation.hasOtherOperation"
        }
      }),
      _vm._v(" "),
      _vm.showOtherOperationDetails
        ? _c(
            "div",
            [
              _c("plain-text-control", {
                attrs: {
                  title: "AidApplication.BasicInfo.OtherOperation.Items.Title",
                  required: true,
                  instructionKey:
                    "AidApplication.BasicInfo.OtherOperation.Items.Title_Instructions"
                }
              }),
              _vm._v(" "),
              _c(
                "table",
                {
                  staticClass: "table tablerow",
                  attrs: {
                    "aria-label": _vm.$t(
                      "AidApplication.BasicInfo.OtherOperation.Items.Title"
                    )
                  }
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "w-20" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "AidApplication.BasicInfo.OtherOperation.Items.Columns.Financing"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "w-25" }, [
                        _c("span", { attrs: { id: "specifier_label" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "AidApplication.BasicInfo.OtherOperation.Items.Columns.Specifier"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "w-10 right" }, [
                        _c(
                          "span",
                          { attrs: { id: "starttime_label" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "AidApplication.BasicInfo.OtherOperation.Items.Columns.StartTime"
                                )
                              ) + " "
                            ),
                            _c("tooltip-icon", {
                              attrs: {
                                content: _vm.$t(
                                  "AidApplication.BasicInfo.OtherOperation.Items.Columns.StartTime_Instructions"
                                )
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "w-10 right" }, [
                        _c(
                          "span",
                          { attrs: { id: "endtime_label" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "AidApplication.BasicInfo.OtherOperation.Items.Columns.EndTime"
                                )
                              ) + " "
                            ),
                            _c("tooltip-icon", {
                              attrs: {
                                content: _vm.$t(
                                  "AidApplication.BasicInfo.OtherOperation.Items.Columns.EndTime_Instructions"
                                )
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "w-15 right" }, [
                        _c("span", { attrs: { id: "aidamount_label" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "AidApplication.BasicInfo.OtherOperation.Items.Columns.AidAmount"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "w-15 right" }, [
                        _c("span", { attrs: { id: "revenue_label" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "AidApplication.BasicInfo.OtherOperation.Items.Columns.Revenue"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "w-5 centered" }, [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    { key: _vm.indexmodified },
                    _vm._l(_vm.otherOperation.items, function(item, index) {
                      return _c(
                        "tr",
                        { key: index },
                        [
                          _vm.financingOptions
                            ? _c("single-select-table-cell", {
                                attrs: {
                                  classes: ["input-cell"],
                                  options: _vm.financingOptions,
                                  required: true,
                                  dropdownId: "financingoptions_" + (index + 1),
                                  srLabel: true,
                                  title:
                                    "AidApplication.BasicInfo.OtherOperation.Items.Columns.Financing"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.clearEndDateIfNeeded(item)
                                  }
                                },
                                model: {
                                  value: item.financing,
                                  callback: function($$v) {
                                    _vm.$set(item, "financing", $$v)
                                  },
                                  expression: "item.financing"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "right input-cell" },
                            [
                              _c("text-area-control", {
                                attrs: {
                                  rows: 1,
                                  maxLength: 200,
                                  required: true,
                                  placeholderKey: "Placeholder.TextArea",
                                  labelledBy: "specifier_label",
                                  showTooltip: true
                                },
                                model: {
                                  value: item.specifier,
                                  callback: function($$v) {
                                    _vm.$set(item, "specifier", $$v)
                                  },
                                  expression: "item.specifier"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "right input-cell" },
                            [
                              _c("date-input-row", {
                                attrs: {
                                  name: "otherOperation_start" + index,
                                  required: false,
                                  placeholder: _vm.$t(
                                    "DatePicker.FormatPlaceholder"
                                  ),
                                  rules: {
                                    required: false,
                                    within: [_vm.minDate, _vm.maxDate],
                                    earlierStr: "@otherOperation_stop" + index
                                  },
                                  labelledBy: "starttime_label"
                                },
                                model: {
                                  value: item.startTime,
                                  callback: function($$v) {
                                    _vm.$set(item, "startTime", $$v)
                                  },
                                  expression: "item.startTime"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "right input-cell" },
                            [
                              _c("date-input-row", {
                                attrs: {
                                  name: "otherOperation_stop" + index,
                                  required: false,
                                  disabled: _vm.isServiceProduction(item),
                                  placeholder: !_vm.isServiceProduction(item)
                                    ? _vm.$t("DatePicker.FormatPlaceholder")
                                    : null,
                                  rules: {
                                    required: false,
                                    within: [null, _vm.maxDate],
                                    laterStr: !_vm.isServiceProduction(item)
                                      ? "@otherOperation_start" + index
                                      : false
                                  },
                                  labelledBy: "endtime_label"
                                },
                                model: {
                                  value: item.endTime,
                                  callback: function($$v) {
                                    _vm.$set(item, "endTime", $$v)
                                  },
                                  expression: "item.endTime"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: [
                                _vm.isAidAmountReadOnly(item)
                                  ? "disabled-background"
                                  : "",
                                "right input-cell"
                              ]
                            },
                            [
                              _c("numeric-input-control", {
                                attrs: {
                                  required: !_vm.isAidAmountReadOnly(item),
                                  disabled: _vm.isAidAmountReadOnly(item),
                                  labelledBy: "aidamount_label"
                                },
                                model: {
                                  value: item.aidAmount,
                                  callback: function($$v) {
                                    _vm.$set(item, "aidAmount", $$v)
                                  },
                                  expression: "item.aidAmount"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: [
                                _vm.isRevenueReadOnly(item)
                                  ? "disabled-background"
                                  : "",
                                "right input-cell"
                              ]
                            },
                            [
                              _c("numeric-input-control", {
                                attrs: {
                                  required: !_vm.isRevenueReadOnly(item),
                                  disabled: _vm.isRevenueReadOnly(item),
                                  labelledBy: "revenue_label"
                                },
                                model: {
                                  value: item.revenue,
                                  callback: function($$v) {
                                    _vm.$set(item, "revenue", $$v)
                                  },
                                  expression: "item.revenue"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: [
                                "input-cell centered",
                                _vm.isReadOnly ? "disabled-background" : ""
                              ]
                            },
                            [
                              _vm.showDeleteBtn
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-link btn-contrast",
                                      attrs: {
                                        type: "button",
                                        "aria-label":
                                          _vm.$t("Btn_DeleteRow") +
                                          _vm.$t(
                                            "Accessibility.ConfirmDeleteRow"
                                          )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteRow(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-trash-alt fa-lg centered"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                !_vm.isReadOnly
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          type: "button",
                          disabled: _vm.isAddNewRowDisabled,
                          "aria-disabled": _vm.isAddNewRowDisabled
                        },
                        on: {
                          click: function($event) {
                            return _vm.addNewRow(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("AidApplication.Btn_AddOperation"))
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }